import { render, staticRenderFns } from "./salaryReport.vue?vue&type=template&id=e6a47c54&"
import script from "./salaryReport.vue?vue&type=script&lang=js&"
export * from "./salaryReport.vue?vue&type=script&lang=js&"
import style0 from "./salaryReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports